import { SVGProps } from 'react'

export const CounterPlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12rem"
      height="12rem"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M0 5.1595H5.1595V0H6.26907V5.1595H11.4286V6.26907H6.26907V11.3731H5.1595V6.26907H0V5.1595Z"
        fill="url(#paint0_linear_3827_18544)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3827_18544"
          x1="11.2213"
          y1="-11.1784"
          x2="-14.5936"
          y2="2.31134"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#4F4F4F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
